import React, { useState, useEffect } from "react";
import { Container, Grid } from "@mui/material";
import MKButton from "../../../components/MKButton";
import MKTypography from "../../../components/MKTypography";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import MKBox from "../../../components//MKBox";
// import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import Button from "@mui/material/Button";
import { Link, useNavigate } from "react-router-dom";
// import SimplePricingCard from "./pricecard";
import NewSimplePricingCard from "./newpricecard";
import Modal from "./modal";
import CancelPlan from "./cancelplan";
import Header from "./header";
// import StickyFooter from "../../../footer";
// import StickyFooter from "../../../DefaultFooter/index";
// import footerroutes from "../../../footerroutes";
import NewFooter from "../../../footer/newFooter";
import CompareTable from "./compareTable";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import Profile from "./profile";
import PaymentProvider from "./payment-provider";
import AlertPopup from "./alertPopup";
import ConfirmPopup from "./confirmPopup";
import BillingAddressDetails from "./billingAddressDetails";
import AddonsList from "./addOns/addonsList";
import CurrentAddons from "./addOns/currentAddons";

import "./style.css";
import "../../../assets/theme/base/globals";
import {
  getmyplan,
  getPlans,
  handleSubscribe,
  getCustomClaim,
  getmyPaymentMethods,
  changePaymentMethods,
  removePaymentMethods,
  taxAddressCheck,
  cancelPlanApi,
} from "../../../providers/planService";
import { getAuth } from "firebase/auth";
import { getMerchantDetails } from "../../../providers/portalURLValidation";
import { formatDate } from "../../../helpers/dateFormat";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
// import Loader from '../../../loader/globelLoader'
import { useParams } from "react-router-dom";
import parse from "html-react-parser";
import Lottie from "lottie-react";
import growLoader from "../../../assets/animation/growLoader.json";
import { useRef } from "react";
import { useLocation } from "react-router-dom";
import { getPaymentSessionDetails } from "../../../providers/addonGrow";
import AddOnStatusModal from "./addOns/addonStatusModal";
import Divider from "@mui/material/Divider";
import { downloadInvoice } from "../../../providers/invoiceService";
import PremiumContactUsModal from "./premiumContactUs";

import { downloadInvoicePopup } from "../../../providers/invoiceService";

let CurrencyFormat = require("react-currency-format");

// Helper function to check if subscription is managed by app store
const isAppStorePlatform = (platform) => {
  return platform === "ios" || platform === "android";
};

// Helper function to check if subscription is managed by app store
const isFreePlatform = (plancode) => {
  return plancode === 'sp_growth_trial' || plancode === 'sp_free365'
};

// Platform information for banners
const getPlatformInfo = (platform) => {
  const platformData = {
    ios: {
      name: "Apple App Store",
      deviceName: "iOS",
      color: "#E3F2FD",
      textColor: "#1565C0",
    },
    android: {
      name: "Google Play Store",
      deviceName: "Android",
      color: "#E8F5E9",
      textColor: "#2E7D32",
    },
  };
  return platformData[platform] || null;
};

const ChangePlanForm = () => {
  const navigate = useNavigate();

  // Helper function to get Firebase token
  const getToken = () => {
    return getAuth()
      .currentUser?.getIdToken(true)
      .then((idToken) => {
        return idToken;
      });
  };
  const [loader, setLoader] = useState(true);
  const { id } = useParams();
  const search = useLocation().search;
  const session_id = new URLSearchParams(search).get("session_id");

  const [planDetail, setPlanDetail] = useState({
    expirydate: "",
    planname: "",
    plancode: "",
    priceType: "",
    amount: 0,
    interval: "",
    isFree: false,
    nextBillingPeriod: "",
    platform: "web", // 'web', 'ios', or 'android'
  });

  const [paymentMethod, setPaymentMethod] = useState({
    card: "",
    cardLastDigit: "",
    expiry: "",
    name: "",
    email: "",
    phone: "",
  });

  const [planList, setPlanList] = useState([]);
  const [merchName, setmerchName] = useState("");
  const [merchantURL, setMerchantURL] = useState("");
  const [paymentMethodLoading, setPaymentMethodLoading] = useState(false);
  const [cardLoading, setCardLoading] = useState(false);
  const [profileDetails, setProfileDetails] = useState({
    name: "",
    email: "",
    phone: "",
  });
  const [merchDet, setMerchDet] = useState({});
  const [addonList, setAddonList] = useState([]);
  const [alignment, setAlignment] = React.useState("yearly");
  const [displayPlanList, setDisplayPlanList] = React.useState([]);
  const [cancelQty, setCancelQty] = useState(1);

  const [modal, setModal] = useState(false);
  const [cancelmodal, setCancelModal] = useState(false);

  const [comparePlanShow, setComparePlanShow] = useState(false);

  const [selectPlan, setSelectPlan] = useState(null);

  const [showPageLoader, setPageLoader] = useState(true);

  const [alertMessage, setAlertMessage] = useState("");
  const [alertReason, setAlertReason] = useState("");
  const [confirmPopup, setconfirmPopup] = useState(false);
  const [addOnLoading, setAddOnLoading] = useState(false);
  const [alertPopup, setAlertPopup] = useState(false);
  const [addonStatusModal, setAddonStatusModal] = useState(false);
  const [addonStatusData, setAddonStatusData] = useState({});
  const [showContactUsPopup, setShowContactUsPopup] = useState(false);

  const starter = `
  <ul style="margin-left: 10px;line-height:2; padding-inline-start:0px">
  <b>All the benefits of Free, and:</b>
  <li>No revenue limit </li>
  <li>Advanced dashboard </li>
  <li>Realtime notifications and reports </li>
  
  and more...
  </ul>
  `;
  // Removed content
  // < li > 3 users</li>
  //   <li>1 locations</li>
  //   <li>2 terminals per location</li>

  const growth = `
  <ul style="margin-left: 10px;line-height:2; padding-inline-start:0px">
  <b>All the benefits of Starter, and:</b>
  <li>Your own website</li>
  <li>Marketplace</li>
  <li>Run your own discount program</li>
  <li>Run your own gift card programs</li>
  <li>Point of sale in <br class="tool"> offline mode <div class="tooltip">&#9432;<span class="tooltiptext">Use Point of Sale feature in ShelfPerks App even without internet for 24 hours</span></div></br></li>
  <li>Expiration reports & alerts</li>
  <li>Smart AI based Purchase Orders</li>
  <li>5 users</li>
  <li>2 locations</li>
  <li>2 terminals per location</li>
  and more...
  </ul>
  `;
  const premium = `
  <ul style="margin-left: 10px;line-height:2; padding-inline-start:0px">
  <b style="textAlign:left">All the benefits of Growth, and</b>:
  <li> Customer loyalty program</li>
  <li>Self checkout</li>
  <li>Up to 500 marketing emails</li>
  <li>Delivery app integration</li>
  <li>Live support</li>
  <li>8 users</li>
  <li>2 locations</li>
  <li>3 terminals per location</li>
  and much more...
  </ul>
  `;
  //  Removed content
  //  Your own website
  //  Marketplace
  useEffect(() => {
    if (id) {
      upgradePlan(id, "paid_regular");
    }
    async function fetchData() {
      // You can await here
      console.log("fetchData started");
      setPaymentMethodLoading(false);
      const myplanResult = await planApi();
      const planDetail = myplanResult.data;

      const planResult = await getPlans();
      const allPlanList = planResult.data;

      if (allPlanList && allPlanList.length) {
        setPlanList(allPlanList);
        // planTypeBaseList(planDetail.subscriptions.priceType, allPlanList)
        planTypeBaseList("yearly", allPlanList);
      }

      const token = await getCustomClaim();
      setmerchName(token.claims.merchName);
      setMerchantURL(token.claims.merchUrl);
      const details = await getMerchantDetails(token.claims.merchUrl);
      const data = details.data.ResponseData.data.data;
      setMerchDet(data);
      const detailObj = {
        name: data.FIRST_NAME + " " + data.LAST_NAME,
        email: data.MERCHANT_EMAIL,
        phone: data.MERCHANT_PHONE,
      };
      setProfileDetails(detailObj);

      // Call paymentMethods after profileDetails is set
      paymentMethods();
      setPageLoader(false);
      if (session_id) {
        getPaymentDetails(session_id);
      }
      // ...
    }
    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const doggleChange = (event, newAlignment) => {
    planTypeBaseList(newAlignment, planList);
  };

  const planApi = async () => {
    setLoader(true);
    try {
      const myplanResult = await getmyplan();
      if (myplanResult && myplanResult.data) {
        const planDetail = myplanResult.data;
        if (planDetail && planDetail.subscriptions) {
          setPlanDetail(planDetail.subscriptions);
        }
      }
      setLoader(false);
      return myplanResult;
    } catch (error) {
      console.error("Error fetching plan data:", error);
      setLoader(false);
      // Set default plan state if API fails
      setPlanDetail({
        planname: "",
        priceType: "",
        plancode: "",
        expirydate: "",
        isFree: true,
        amount: 0,
        interval: "",
        nextBillingPeriod: "",
        platform: "web",
      });
      return null;
    }
  };

  const paymentMethods = async () => {
    // For Razorpay, we don't store payment methods
    // Set default state showing Razorpay is ready
    setPaymentMethod({
      card: "",
      cardLastDigit: "",
      expiry: "",
      name: profileDetails?.name || "",
      email: profileDetails?.email || "",
      phone: profileDetails?.phone || "",
      razorpayReady: true,
    });
    setPaymentMethodLoading(true);
  };

  const getMonthTwoDigit = (value) => {
    let month = "";
    if (value) {
      if (value < 10) {
        month = "0" + value;
      } else {
        month = value;
      }
    }
    return month;
  };

  const planTypeBaseList = (type, allPlanList) => {
    if (type) {
      setAlignment(type);
      const dispList = [];
      for (const planObj of allPlanList) {
        const planpriceList = planObj.plan_price;
        let filterList = planpriceList.filter((x) => x.price_type === type);

        if (planpriceList.length === 1) {
          filterList = planpriceList;
        }

        const clonePlanObj = {
          planName: planObj.plan_name,
          planCode: planObj.plancode,
          planPrice: filterList,
        };
        dispList.push(clonePlanObj);
      }
      setDisplayPlanList(dispList);
    }
  };

  const getDisplayPlanDetail = (index) => {
    const findPlan = displayPlanList.find((x) => x.planName === index);

    return findPlan || null;
  };

  const priceAction = (param, plan) => {
    if (plan === "Premium") {
      toggleContactUsModal();
    } else {
      const findPlan = planList.find((x) => x.plan_name === plan.toLowerCase());
      if (findPlan) {
        const findPlanName = findPlan.plan_price.find(
          (x) => x.price_type === alignment
        );
        console.log("findPlanName", findPlanName);
        const planObj = {
          planCode: undefined,
          planName: plan.toLowerCase(),
          planPrice: [{ ...findPlanName }],
        };
        setSelectPlan(planObj);
      }

      toggleModal();
    }
  };

  async function upgradePlan(param, type) {
    console.log("=== upgradePlan called ===");
    console.log("param (plan code):", param);
    console.log("type:", type);
    console.log("displayPlanList:", displayPlanList);

    navigateToPlanCard();
    setLoader(true);

    // Handle free plan directly without Razorpay logic
    if (type === "free" || param === "sp_free365") {
      console.log("Processing free plan - skipping Razorpay checkout");
      try {
        // For free plan, just update the subscription directly via backend
        const result = await handleSubscribe(param, "free");
        console.log("Free plan subscription result:", result);
        console.log("result", result);
        if (result.status === 200) {
          console.log("Free plan activated successfully");
          await planApi();
          childCompRef.current?.refreshAddOn();
        } else {
          setAlertMessage("Failed to activate free plan");
          setAlertReason("free_plan_failed");
          toggleAlertModal();
        }
      } catch (error) {
        console.error("Error activating free plan:", error);
        setAlertMessage("Failed to activate free plan");
        setAlertReason("free_plan_failed");
        toggleAlertModal();
      }
      setLoader(false);
      return;
    }

    try {
      const checkTax = await taxAddressCheck();
      if (checkTax.status === 200) {
        if (checkTax.data.tax_enabled !== 0) {
          setAlertReason("");
          setAlertMessage(checkTax.data.tax_status);
          setAlertPopup(true);
          setLoader(false);
          return;
        }
      }

      // Check if Razorpay is loaded
      if (typeof window.Razorpay === "undefined") {
        setAlertMessage("Razorpay is not loaded. Please refresh the page.");
        setAlertReason("razorpay_not_loaded");
        toggleAlertModal();
        setLoader(false);
        return;
      }

      // The backend will handle any existing subscription cancellation/refunds automatically
      console.log(
        "Backend will handle any existing subscription changes automatically"
      );

      // Get plan details and pricing
      console.log("Looking for plan with param:", param);
      console.log(
        "Available plans:",
        displayPlanList?.map((p) => ({
          planCode: p.planCode,
          planName: p.planName,
          planPrices: p.planPrice?.map((pp) => pp.code),
        }))
      );

      // The param could be either a plan name or a pricing code (sp_stan30, sp_prem30, etc.)
      // First try to match by pricing code, then by plan name
      let planIndex = displayPlanList.findIndex((plan) =>
        plan.planPrice?.some((price) => price.code === param)
      );

      // If not found by pricing code, try by plan name
      if (planIndex === -1) {
        planIndex = displayPlanList.findIndex(
          (plan) => plan.planName === param
        );
      }

      console.log("Plan index found:", planIndex);

      const selectedPlan = getDisplayPlanDetail(selectPlan.planName);
      console.log("Selected plan:", selectedPlan);

      if (!selectedPlan) {
        console.error(
          "Plan not found - param:",
          param,
          "displayPlanList:",
          displayPlanList
        );
        setAlertMessage("Plan not found");
        setAlertReason("plan_not_found");
        toggleAlertModal();
        setLoader(false);
        return;
      }

      // Find the specific price that matches the param (if param is a pricing code)
      let planPrice = selectedPlan.planPrice.find(
        (price) => price.code === param
      );

      // If not found by pricing code, use the first available price
      if (!planPrice) {
        planPrice = selectedPlan.planPrice[0];
      }

      console.log("Selected plan price:", planPrice);
      const amount = Math.round(planPrice.price * 100); // Convert to paisa

      // Use the pricing code - if param is already a pricing code, use it; otherwise use the plan price code
      const actualPlanCode = selectedPlan.planPrice.some(
        (price) => price.code === param
      )
        ? param
        : planPrice.code;
      console.log("Using actual plan code:", actualPlanCode);

      // Get Razorpay plan ID from backend
      try {
        const planIdResult = await fetch(
          window.spconfig?.config.billingUrl + "/billing/razorpay/get_plan_id",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + (await getToken()),
            },
            body: JSON.stringify({
              sp_code: actualPlanCode,
            }),
          }
        );

        const planIdData = await planIdResult.json();
        console.log("Plan ID response:", planIdData);

        if (!planIdData.success || !planIdData.razorpay_plan_id) {
          setAlertMessage(
            planIdData.message || "Plan not configured for Razorpay"
          );
          setAlertReason("plan_not_configured");
          toggleAlertModal();
          return;
        }

        // Check if Razorpay is loaded
        if (typeof window.Razorpay === "undefined") {
          setAlertMessage("Razorpay is not loaded. Please refresh the page.");
          setAlertReason("razorpay_not_loaded");
          toggleAlertModal();
          return;
        }

        // Create subscription on backend first, then open checkout
        const subscriptionResult = await fetch(
          window.spconfig?.config.billingUrl +
            "/billing/razorpay/create_subscription",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + (await getToken()),
            },
            body: JSON.stringify({
              sp_code: actualPlanCode,
              plan_id: planIdData.razorpay_plan_id,
            }),
          }
        );

        const subscriptionData = await subscriptionResult.json();
        console.log("Subscription creation response:", subscriptionData);

        if (!subscriptionData.success) {
          setAlertMessage(
            subscriptionData.message || "Failed to create subscription"
          );
          setAlertReason("subscription_creation_failed");
          toggleAlertModal();
          return;
        }

        // Open Razorpay payment for the created subscription
        const options = {
          key: planIdData.razorpay_key,
          subscription_id: subscriptionData.subscription_id,
          name: "ShelfPerks",
          description: `${selectedPlan.planName} Plan - ${planPrice.price_type}`,
          handler: async function (response) {
            setLoader(true);
            try {
              // Handle subscription success callback
              const callbackResult = await fetch(
                window.spconfig?.config.billingUrl +
                  "/billing/razorpay/subscription_callback",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + (await getToken()),
                  },
                  body: JSON.stringify({
                    razorpay_subscription_id: response.razorpay_subscription_id,
                    razorpay_payment_id: response.razorpay_payment_id,
                    razorpay_signature: response.razorpay_signature,
                    sp_code: actualPlanCode,
                    type: type,
                  }),
                }
              );

              const callbackData = await callbackResult.json();
              console.log("Subscription callback response:", callbackData);

              if (callbackData.success) {
                // Check if refund was processed for previous subscription
                if (callbackData.refund_processed) {
                  setAlertReason("Success");
                  setAlertMessage(
                    `Subscription activated successfully! Previous subscription cancelled with refund of ${callbackData.refund_currency} ${callbackData.refund_amount} for ${callbackData.refund_remaining_days} remaining days.`
                  );
                  setAlertPopup(true);

                  // Delay redirect to show refund message
                  setTimeout(async () => {
                    await planApi();
                    window.location.href =
                      window.spconfig?.config.siteURL + "/#/plan";
                  }, 3000);
                } else {
                  // Update local subscription state and redirect immediately
                  await planApi();
                  window.location.href =
                    window.spconfig?.config.siteURL + "/#/plan";
                }
              } else {
                setAlertMessage(
                  callbackData.message || "Subscription activation failed"
                );
                setAlertReason("subscription_activation_failed");
                toggleAlertModal();
              }
            } catch (error) {
              console.error("Subscription callback error:", error);
              setAlertMessage("Failed to activate subscription");
              setAlertReason("subscription_callback_error");
              toggleAlertModal();
            }
            setLoader(false);
          },
          prefill: {
            name: profileDetails.name,
            email: profileDetails.email,
            contact: profileDetails.phone,
          },
          theme: {
            color: "#50B748",
          },
          modal: {
            ondismiss: function () {
              setLoader(false);
              setAlertMessage("Subscription cancelled");
              setAlertReason("user_cancelled");
              toggleAlertModal();
            },
          },
        };
        console.log("------options", options);
        const rzp = new window.Razorpay(options);
        rzp.open();
      } catch (error) {
        console.error("Plan ID fetch error:", error);
        setAlertMessage("Failed to get plan details");
        setAlertReason("plan_fetch_error");
        toggleAlertModal();
      }
    } catch (error) {
      console.error("Error in upgradePlan:", error);
      setAlertMessage("An error occurred while processing your request");
      setAlertReason("network_error");
      toggleAlertModal();
    } finally {
      setLoader(false);
    }
  }

  async function changePaymentMethod() {
    const result = await changePaymentMethods();
    if (result.data.sessionURL) {
      window.location.href = result.data.sessionURL;
    }
  }

  async function removePaymentMethod() {
    setCardLoading(true);
    setPaymentMethodLoading(true);
    toggleConfirmModal();
    const result = await removePaymentMethods();
    if (result.data.card_detached) {
      await paymentMethods();
    }
    setCardLoading(false);
  }

  const toggleModal = () => {
    setModal(!modal);
  };

  if (modal) {
    document.body.classList.add("active-modal");
  } else {
    document.body.classList.remove("active-modal");
  }

  const toggleCancelModal = () => {
    setCancelModal(!cancelmodal);
  };

  const toggleConfirmModal = () => {
    setconfirmPopup(!confirmPopup);
  };

  const toggleAddonStatusModal = () => {
    setAddonStatusModal(!addonStatusModal);
  };

  const toggleContactUsModal = () => {
    setShowContactUsPopup(!showContactUsPopup);
  };

  if (addonStatusModal) {
    document.body.classList.add("active-addonstatusmodal");
  } else {
    document.body.classList.remove("active-addonstatusmodal");
  }

  if (cancelmodal) {
    document.body.classList.add("active-cancelmodal");
  } else {
    document.body.classList.remove("active-cancelmodal");
  }

  if (alertPopup) {
    document.body.classList.add("active-alertPopup");
  } else {
    document.body.classList.remove("active-alertPopup");
  }

  if (confirmPopup) {
    document.body.classList.add("active-confirmPopup");
  } else {
    document.body.classList.remove("active-confirmPopup");
  }

  if (showContactUsPopup) {
    document.body.classList.add("active-contactusform");
  } else {
    document.body.classList.remove("active-contactusform");
  }

  const toggleAlertModal = () => {
    setAlertPopup(true);
  };

  const handleAlertClose = () => {
    setAlertPopup(false);
  };

  const confirmNo = () => {
    setconfirmPopup(false);
  };

  const cancelPlanToFree = () => {
    toggleCancelModal();
  };

  const cancelModalClose = () => {
    toggleCancelModal();
  };

  const proceedCancelModal = async () => {
    setLoader(true);
    toggleCancelModal();

    try {
      // Cancel the current Razorpay subscription
      const cancelResult = await cancelPlanApi();
      console.log("Subscription cancellation result:", cancelResult);

      if (cancelResult.data && cancelResult.data.success) {
        // Show refund information if applicable
        if (cancelResult.data.refund_amount > 0) {
          setAlertReason("Success");
          setAlertMessage(
            `Subscription cancelled successfully. Refund of ₹ ${cancelResult.data.refund_amount} will be processed for remaining ${cancelResult.data.remaining_days} days.`
          );
        } else {
          setAlertReason("Success");
          setAlertMessage("Subscription cancelled successfully.");
        }
        setAlertPopup(true);
      } else {
        setAlertReason("error");
        setAlertMessage("Failed to cancel subscription. Please try again.");
        setAlertPopup(true);
      }

      // Downgrade to free plan after successful cancellation
      await upgradePlan("sp_free365", "free");
    } catch (error) {
      console.error("Error cancelling subscription:", error);
      setAlertReason("error");
      setAlertMessage("Failed to cancel subscription. Please try again.");
      setAlertPopup(true);
    }

    setTimeout(async () => {
      setLoader(false);
      await planApi();
      childCompRef.current.refreshAddOn();
    }, 3000);
  };

  const modalCancel = () => {
    toggleModal();
  };
  const modalContinue = async () => {
    toggleModal();
    console.log("selectPlan==========>>", selectPlan);
    const planId = selectPlan.planPrice[0].code;
    await upgradePlan(planId, "paid_regular");
  };

  const capitalizeFirstLetter = (planName) => {
    return planName.charAt(0).toUpperCase() + planName.slice(1);
  };

  const NavigateToSubscribeCards = () => {
    // navigate("/plan#planCardDetails")
    document.getElementById("planCardDetails").scrollIntoView();
  };

  const moveToAddons = () => {
    document.getElementById("addons").scrollIntoView();
  };

  const navigateToPlanCard = () => {
    // navigate("/plan#planCardDetails")
    document.getElementById("planCard").scrollIntoView();
  };

  const comparePlan = () => {
    setComparePlanShow(!comparePlanShow);
  };

  const getPaymentDetails = async (id) => {
    toggleAddonStatusModal();
    const sessionDet = await getPaymentSessionDetails(id);
    let data = "";
    if (sessionDet.data.ResponseStatus === "Error") {
      data = "Error";
    } else {
      data = sessionDet.data.ResponseData;
    }
    setAddonStatusData(data);

    return data;
  };

  const [editBillingToggle, setEditBillingToggle] = useState(false);

  const clickEditbillingButton = async () => {
    setEditBillingToggle(!editBillingToggle);
  };

  const childCompRef = useRef();

  return (
    <>
      <Container maxWidth="xxl" id="planCard">
        {" "}
        <Header />{" "}
      </Container>

      {showPageLoader ? (
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          justifyContent="center"
          display="flex"
        >
          <MKBox
            sx={{
              mt: "250px",
              mb: "250px",
              width: "150px",
              height: "150px",
            }}
          >
            <Lottie animationData={growLoader} loop={true} />
          </MKBox>
        </Grid>
      ) : (
        <Container>
          <Grid container justifyContent="start" pt={2.5}>
            <Grid lg={8} container item justifyContent="start">
              <MKTypography
                fontSize="28px"
                style={{
                  fontFamily: "openSansSemiBold",
                  color: "#2E4455",
                  letterSpacing: "0.28px",
                  textAlign: "left",
                  opacity: 1,
                }}
              >
                Hello, {merchName}
              </MKTypography>
            </Grid>
          </Grid>

          <Grid container>
            <>
              {loader ? (
                <Card
                  sx={{
                    minWidth: 275,
                    mt: "24px",
                    width: "100%",
                    boxShadow: "#2E445529",
                    borderRadius: 1,
                    boxShadow: 3,
                  }}
                  // style={{ boxShadow: "0px 2px 1px -1px #2E445529" }}
                >
                  {/* <Loader.GlobaLoader /> */}
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    justifyContent="center"
                    display="flex"
                  >
                    <MKBox
                      sx={{
                        width: "150px",
                        height: "150px",
                      }}
                    >
                      <Lottie animationData={growLoader} loop={true} />
                    </MKBox>
                  </Grid>
                </Card>
              ) : (
                <Card
                  sx={{
                    minWidth: 275,
                    mt: "32px",
                    width: "100%",
                    boxShadow: "#2E445529",
                    borderRadius: 1,
                    boxShadow: 3,
                  }}
                  // style={{ boxShadow: "0px 2px 1px -1px #2E445529" }}
                >
                  <CardContent
                    sx={{ pb: 0, display: { xs: "block", md: "flex" } }}
                  >
                    <Grid container spacing={2}>
                      <Grid
                        item
                        container
                        xs={12}
                        xl={6}
                        lg={6}
                        sm={12}
                        md={6}
                        justifyContent="space-between"
                      >
                        <Grid
                          item
                          container
                          xs={12}
                          lg={12}
                          md={12}
                          sm={12}
                          xl={12}
                          direction="column"
                        >
                          <MKTypography
                            fontSize="14px"
                            style={{
                              color: "#202223",
                              letterSpacing: "0.14px",
                              textAlign: "left",
                              opacity: 1,
                            }}
                          >
                            Current plan
                          </MKTypography>
                          <MKTypography
                            fontSize="24px"
                            style={{
                              color: "#202223",
                              letterSpacing: "0px",
                              textAlign: "left",
                              opacity: 1,
                            }}
                          >
                            {" "}
                            <span className="semi-bold">
                              {" "}
                              {capitalizeFirstLetter(planDetail?.planname)}{" "}
                            </span>
                            <span
                              style={{
                                fontSize: "14px",
                                fontFamily: "OpenSansRegular",
                              }}
                            >
                              {planDetail.plancode === 'sp_growth_trial' || planDetail.plancode === 'sp_free365' ? <span></span> :
                              <>
                               <CurrencyFormat
                                value={planDetail?.amount}
                                displayType={"text"}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                thousandSeparator={true}
                                prefix={"₹"}
                                renderText={(value) => <span> {value} </span>}
                              />{" "}
                              <span> + GST </span>{" "}
                              {planDetail?.priceType &&
                              planDetail?.priceType === "monthly"
                                ? "billed Monthly"
                                : "billed Annually"}
                              </> }
                             
                            </span>
                          </MKTypography>
                        </Grid>
                        {planDetail?.isFree === false ? (
                          <Grid
                            item
                            container
                            xs={12}
                            lg={12}
                            md={12}
                            sm={12}
                            direction="row"
                          >
                            <Grid
                              item
                              xs={12}
                              sx={{
                                listStyle: "none",
                                display: "flex",
                                flexDirection: { xs: "row" },
                              }}
                              justifyContent="space-between"
                            >
                              <MKBox>
                                <MKTypography
                                  fontSize="14px"
                                  className="opensans-regular"
                                  sx={{ mt: 4 }}
                                  style={{
                                    color: "#202223",
                                    letterSpacing: "0.14px",
                                    textAlign: "left",
                                    opacity: 1,
                                  }}
                                >
                                  Expiry Date
                                </MKTypography>
                                <MKTypography
                                  fontSize="16px"
                                  className="semi-bold"
                                  style={{
                                    color: "#202223",
                                    letterSpacing: "0.16px",
                                    textAlign: "left",
                                    opacity: 1,
                                  }}
                                >
                                  on{" "}
                                  {formatDate(
                                    planDetail?.expirydate,
                                    "billing"
                                  )}
                                </MKTypography>
                              </MKBox>
                              <MKBox>
                                <MKTypography
                                  fontSize="14px"
                                  className="opensans-regular"
                                  sx={{ mt: 4 }}
                                  style={{
                                    color: "#202223",
                                    letterSpacing: "0.14px",
                                    textAlign: "left",
                                    opacity: 1,
                                  }}
                                >
                                  Next billing date
                                </MKTypography>
                                <MKTypography
                                  fontSize="16px"
                                  className="semi-bold"
                                  style={{
                                    color: "#202223",
                                    letterSpacing: "0.16px",
                                    textAlign: "left",
                                    opacity: 1,
                                  }}
                                >
                                  on{" "}
                                  {formatDate(
                                    planDetail?.nextBillingPeriod,
                                    "billing"
                                  )}
                                </MKTypography>
                              </MKBox>
                            </Grid>
                          </Grid>
                        ) : (
                          ""
                        )}
                      </Grid>
                      <Grid
                        item
                        lg={6}
                        xl={6}
                        sm={12}
                        md={6}
                        xs={12}
                        mt="32px"
                        container
                        sx={{ justifyContent: { md: "end", xs: "start" } }}
                      >
                        <MKBox
                          ml={2}
                          sx={{
                            display: "inline-block",
                            ml: {
                              xl: "120px",
                              lg: "10px",
                              md: "60px",
                              sm: "0px",
                              xs: "0px",
                            },
                          }}
                        >
                          <MKButton
                            variant="outlined"
                            color="primary"
                            className="upgrade"
                            size="medium"
                            disabled={isFreePlatform(planDetail?.plancode)}
                            sx={{
                              fontSize: "14px",
                              borderRadius: "4px",
                              
                             
                              mr: { xs: "50px", sm: "50px", md: "50px" },
                              verticalAlign: "middle",
                              lineHeight: 1.5,
                              textTransform: "capitalize",
                              opacity: isFreePlatform(planDetail?.plancode) ? 0.5 : 1,
                              color: isFreePlatform(planDetail?.plancode) ? "#BDBDBD" : "#50B748",
                              borderColor: isFreePlatform(planDetail?.plancode) ? "#BDBDBD" : "#50B748",
                            }}
                            onClick={moveToAddons}
                          >
                            Add-Ons
                          </MKButton>
                          <MKButton
                            onClick={NavigateToSubscribeCards}
                            variant="contained"
                            color="primary"
                            size="medium"
                            disabled={isAppStorePlatform(planDetail?.platform)}
                            sx={{
                              ":hover": {
                                bgcolor: isAppStorePlatform(
                                  planDetail?.platform
                                )
                                  ? "#BDBDBD"
                                  : "#50B748",
                                color: "#FFFFFF",
                              },
                              textTransform: "capitalize",
                              fontSize: "14px",
                              width: { sm: "142px", xs: "142px", md: "auto" },
                              mb: { xs: "10px", sm: "0px" },
                              opacity: isAppStorePlatform(planDetail?.platform)
                                ? 0.5
                                : 1,
                            }}
                            className="upgrade"
                          >
                            Upgrade
                          </MKButton>
                        </MKBox>
                      </Grid>

                      {/* <div style={{ marginTop: "30px" }}>
                                            <hr sx={
                                                { color: "#DCDCDC" }
                                            } />
                                        </div> */}

                      {/* Platform Banner for iOS/Android subscriptions */}
                      {isAppStorePlatform(planDetail?.platform) &&
                        getPlatformInfo(planDetail?.platform) && (
                          <Grid
                            item
                            size={12}
                           
                            justifyContent="space-between"
                          >
                            <MKBox
                              sx={{
                                backgroundColor: getPlatformInfo(
                                  planDetail?.platform
                                )?.color,
                                borderRadius: "8px",
                                padding: "16px",
                                border: `1px solid ${
                                  getPlatformInfo(planDetail?.platform)
                                    ?.textColor
                                }40`,
                              }}
                            >
                              <Grid container alignItems="center" spacing={2}>
                                <Grid item xs={12}>
                                  <MKTypography
                                    fontSize="16px"
                                    style={{
                                      fontFamily: "openSansSemiBold",
                                      color: getPlatformInfo(
                                        planDetail?.platform
                                      )?.textColor,
                                      marginBottom: "8px",
                                    }}
                                  >
                                    ⓘ You subscribed through{" "}
                                    {
                                      getPlatformInfo(planDetail?.platform)
                                        ?.name
                                    }
                                  </MKTypography>
                                  <MKTypography
                                    fontSize="14px"
                                    style={{
                                      color: "#5F6368",
                                      lineHeight: "1.5",
                                    }}
                                  >
                                    Your subscription is managed by{" "}
                                    {
                                      getPlatformInfo(planDetail?.platform)
                                        ?.name
                                    }{" "}
                                    and can only be changed or cancelled through
                                    your{" "}
                                    {
                                      getPlatformInfo(planDetail?.platform)
                                        ?.deviceName
                                    }{" "}
                                    device. Please use your{" "}
                                    {
                                      getPlatformInfo(planDetail?.platform)
                                        ?.deviceName
                                    }{" "}
                                    device to manage your subscription.
                                  </MKTypography>
                                </Grid>
                              </Grid>
                            </MKBox>
                          </Grid>
                        )}
                    </Grid>
                  </CardContent>
                  <Divider variant="middle" sx={{ mt: "24px" }} />
                  <CardActions>
                    {planDetail?.isFree === false &&
                    !isAppStorePlatform(planDetail?.platform) ? (
                      <MKButton
                        className="btn-txt opensans-medium"
                        onClick={cancelPlanToFree}
                        sx={{
                          fontSize: "14px",
                          marginRight: {
                            xl: "90px",
                            lg: "90px",
                            md: "90px",
                            sm: "45px",
                            xs: "0px",
                          },
                          pr: { xs: "10px", sm: "20px" },
                          backgroundColor: "transparent !important",
                          boxShadow: "none !important",
                          border: "none !important",
                          textDecoration: "none",
                          "&:hover": {
                            backgroundColor: "transparent !important",
                            boxShadow: "none !important",
                          },
                          "&:focus": {
                            backgroundColor: "transparent !important",
                            boxShadow: "none !important",
                          },
                        }}
                        size="medium"
                        variant="text"
                        color="primary"
                      >
                        Cancel Plan
                      </MKButton>
                    ) : (
                      ""
                    )}
                    <Link to={"/invoice"} style={{ textDecoration: "none" }}>
                      <MKButton
                        className="btn-txt opensans-medium"
                        sx={{
                          fontSize: "14px",
                          marginRight: {
                            xl: "90px",
                            lg: "90px",
                            md: "90px",
                            sm: "45px",
                            xs: "0px",
                          },
                          pr: { xs: "10px", sm: "20px" },
                          pl: { xs: "10px", sm: "20px" },
                          backgroundColor: "transparent !important",
                          boxShadow: "none !important",
                          border: "none !important",
                          textDecoration: "none",
                          "&:hover": {
                            backgroundColor: "transparent !important",
                            boxShadow: "none !important",
                          },
                          "&:focus": {
                            backgroundColor: "transparent !important",
                            boxShadow: "none !important",
                          },
                        }}
                        size="small"
                        variant="text"
                        color="primary"
                      >
                        Past Invoices
                      </MKButton>
                    </Link>
                    <a
                      href="https://support.shelfperks.in"
                      target="_blank"
                      style={{ textDecoration: "none" }}
                    >
                      <MKButton
                        className="btn-txt opensans-medium"
                        sx={{
                          fontSize: "14px",
                          pr: { xs: "10px", sm: "20px" },
                          pl: { xs: "10px", sm: "20px" },
                          backgroundColor: "transparent !important",
                          boxShadow: "none !important",
                          border: "none !important",
                          textDecoration: "none",
                          "&:hover": {
                            backgroundColor: "transparent !important",
                            boxShadow: "none !important",
                          },
                          "&:focus": {
                            backgroundColor: "transparent !important",
                            boxShadow: "none !important",
                          },
                        }}
                        size="small"
                        variant="text"
                        color="primary"
                      >
                        Get Help
                      </MKButton>
                    </a>
                  </CardActions>
                </Card>
              )}
            </>
          </Grid>

          <PaymentProvider />

          <Profile
            profileDetails={profileDetails}
            merchantURL={merchantURL}
            setProfileDetails={setProfileDetails}
          />

          <Grid container>
            <Card
              sx={{
                minWidth: 275,
                mt: "24px",
                width: "100%",
                boxShadow: "#2E445529",
                borderRadius: 1,
                minHeight: 215,
                boxShadow: 3,
              }}
              // style={{ boxShadow: "0px 2px 1px -1px #2E445529" }}
            >
              {/* <MKTypography fontSize="14px" style={{ mb: 1, color: "#202223", letterSpacing: "0px", textAlign: "left", opacity: 1, lineHeight: 2 }}> <span> Payment Method </span></MKTypography> */}

              {!cardLoading && !paymentMethodLoading ? (
                <Grid
                  item
                  xs={12}
                  sx={{
                    justifyContent: "center",
                    alignContent: "center",
                    textAlign: "center",
                  }}
                >
                  <MKBox
                    sx={{
                      ml: { lg: 65, sm: 35, md: 50, xs: 20 },
                      width: 100,
                      height: 100,
                    }}
                  >
                    <Lottie animationData={growLoader} loop={true} />
                  </MKBox>
                </Grid>
              ) : (
                <CardContent
                  sx={{ pb: 0, display: { xs: "block", md: "flex" } }}
                >
                  <Grid item container xs={12}>
                    {/* <Grid item container xs={12} sm={12} md={12} lg={4} > */}
                    {/* Payment gateway info removed - Razorpay is the only option */}
                    {/* </Grid> */}
                    <Grid item container xs={12} sm={12} md={12} lg={12}>
                      <BillingAddressDetails
                        merchantURL={merchantURL}
                        merchDet={merchDet}
                        toggleChange={setEditBillingToggle}
                        toggleValue={editBillingToggle}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              )}
              <Divider variant="middle" sx={{ mt: "24px", mb: "8px" }} />

              <CardActions>
                <MKButton
                  className="btn-txt opensans-medium"
                  onClick={() => {
                    clickEditbillingButton();
                  }}
                  sx={{
                    fontSize: "14px",
                    marginRight: {
                      xl: "90px",
                      lg: "90px",
                      md: "90px",
                      sm: "45px",
                      xs: "0px",
                    },
                    pr: { xs: "10px", sm: "20px" },
                    pl: "8px",
                    backgroundColor: "transparent !important",
                    boxShadow: "none !important",
                    border: "none !important",
                    textDecoration: "none",
                    "&:hover": {
                      backgroundColor: "transparent !important",
                      boxShadow: "none !important",
                    },
                    "&:focus": {
                      backgroundColor: "transparent !important",
                      boxShadow: "none !important",
                    },
                  }}
                  size="small"
                  variant="text"
                  color="primary"
                >
                  Update Details
                </MKButton>
              </CardActions>
            </Card>
          </Grid>

          {/* < BillingAddressDetails merchantURL={merchantURL} merchDet={merchDet} /> */}

          <MKTypography
            id="planCardDetails"
            mt="60px"
            className="upgrade"
            mb={3}
            sx={{
              fontSize: { xs: "18px", md: "18px" },
              letterSpacing: "0.18px",
              opacity: 1,
            }}
            style={{ fontWeight: "600", color: "#202223" }}
            textAlign="center"
          >
            Upgrade your subscription to
          </MKTypography>
          <MKBox
            className="upgrade"
            mb={4}
            sx={{
              fontSize: { xs: "18px", md: "18px" },
              letterSpacing: "0.18px",
              opacity: 1,
            }}
            style={{ fontWeight: "600", color: "#202223" }}
            textAlign="center"
          >
            <ToggleButtonGroup
              color="primary"
              exclusive
              onChange={doggleChange}
              value={alignment}
            >
              <ToggleButton
                size="large"
                sx={{
                  color: "#202223",
                  fontSize: "18px",
                  height: "46px",
                  width: "115px",
                }}
                value="yearly"
              >
                Yearly
              </ToggleButton>
              <ToggleButton
                size="large"
                sx={{
                  color: "#202223",
                  fontSize: "18px",
                  height: "46px",
                  width: "115px",
                }}
                value="monthly"
              >
                Monthly
              </ToggleButton>
            </ToggleButtonGroup>
          </MKBox>

          <Grid
            container
            sx={{ mt: 1 }}
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item ml="15px" mr="15px" maxWidth="314px">
              <NewSimplePricingCard
                variant="outlined"
                color="primary"
                title="Starter"
                description={
                  <span>
                    <b>
                      Advanced features to grow your business with no revenuew
                      cap
                    </b>
                  </span>
                }
                currentPlan={planDetail}
                planDetail={getDisplayPlanDetail("starter")}
                alignment={alignment}
                price={{
                  value: "599",
                  currency: "₹",
                  duration: (
                    <span>
                      <b>per month</b>
                    </span>
                  ),
                }}
                action={{
                  variant: "outlined",
                  type: "internal",
                  route: "/",
                  label: "Upgrade",
                }}
                specifications={parse(starter)}
                handleAction={(e) => priceAction(e, "Starter")}
              />
            </Grid>
            <Grid item ml="15px" mr="15px" maxWidth="314px">
              <NewSimplePricingCard
                variant="outlined"
                color="primary"
                title="Growth"
                currentPlan={planDetail}
                planDetail={getDisplayPlanDetail("growth")}
                alignment={alignment}
                description={
                  <span>
                    <b>
                      Sell more at our marketplace, have your own website and attract more customers with powerful features
                    </b>
                  </span>
                }
                price={{
                  value: "1299",
                  currency: "₹",
                  duration: (
                    <span>
                      <b>per month</b>
                    </span>
                  ),
                }}
                action={{
                  variant: "outlined",
                  type: "internal",
                  route: "/",
                  label: "Upgrade",
                }}
                specifications={parse(growth)}
                handleAction={(e) => priceAction(e, "Growth")}
              />
            </Grid>

            <Grid item ml="15px" mr="15px" maxWidth="314px">
              <NewSimplePricingCard
                variant="outlined"
                color="primary"
                title="Premium"
                currentPlan={planDetail}
                planDetail={getDisplayPlanDetail("premium")}
                alignment={alignment}
                description={
                  <span>
                    <b>
                      Save labour cost with self-checkout feature and supercharge your business with customer loyalty programme
                    </b>
                  </span>
                }
                price={{
                  value: "7199",
                  currency: "₹",
                  duration: (
                    <span>
                      <b>per month</b>
                    </span>
                  ),
                }}
                action={{
                  variant: "outlined",
                  type: "internal",
                  route: "/",
                  label: "Upgrade",
                }}
                specifications={parse(premium)}
                handleAction={(e) => priceAction(e, "Premium")}
              />
            </Grid>
          </Grid>
          <MKTypography
            mt={3}
            mb={3}
            sx={{
              fontSize: { xs: "14px", md: "14px" },
              letterSpacing: "0px",
              opacity: 1,
              color: "#50B748",
            }}
            textAlign="center"
          >
            {/* <ArrowRightAltIcon style={{ verticalAlign: "middle" }}>
                        ArrowRightAlt
                    </ArrowRightAltIcon> */}
            <Button
              variant="text"
              sx={{
                color: "#50B748",
                fontFamily: "openSansSemiBold",
              }}
              onClick={comparePlan}
            >
              COMPARE PLANS +
            </Button>
          </MKTypography>
          {comparePlanShow ? (
            <>
              <Grid container id="planComparison">
                <Grid item xs={12} sx={{ mt: { xs: 5, lg: 10 } }}>
                  <CompareTable />
                </Grid>
                <Grid item xs={12} sx={{ mt: 3 }}>
                  <MKTypography variant="span" className="tableNote">
                    * ₹50 is a fee to enable integrated payment providers. It is
                    charged monthly per provider account per location.
                    <br />
                    ** 1 new Location add-on comes with 1 additional terminal
                    and 1 additional user. <br />
                    During 14 day trial, you can choose any plan of your choice.
                    After 14 day trial, if you do not select a plan, your account
                    will be downgraded to the Free plan. All prices are
                    exclusive of applicable taxes.
                  </MKTypography>
                </Grid>
              </Grid>
              <MKTypography
                mt={3}
                mb={3}
                sx={{
                  fontSize: { xs: "14px", md: "14px" },
                  letterSpacing: "0px",
                  opacity: 1,
                  color: "#50B748",
                }}
                textAlign="center"
              >
                {/* <ArrowRightAltIcon style={{ verticalAlign: "middle" }}>
                        ArrowRightAlt
                    </ArrowRightAltIcon> */}

                <Button
                  variant="text"
                  sx={{
                    color: "#50B748",
                    fontFamily: "openSansSemiBold",
                  }}
                  onClick={NavigateToSubscribeCards}
                >
                  <KeyboardDoubleArrowUpIcon
                    style={{ verticalAlign: "middle" }}
                  >
                    ArrowRightAlt
                  </KeyboardDoubleArrowUpIcon>
                  To Top
                </Button>
              </MKTypography>
            </>
          ) : (
            ""
          )}

          <CurrentAddons
            merchName={merchName}
            setAddonList={setAddonList}
            ref={childCompRef}
          />
          <AddonsList
            planName={planDetail?.planname}
            addonListChange={addonList}
            merchName={merchName}
            plan={planDetail}
            setAddonChange={() =>childCompRef.current?.refreshAddOn()}
            // setAddonChange={(event) => {setAddonRefresh(event);console.log("what value coming", event)}}
          />

          <Grid>
            {modal && (
              <Modal
                planData={selectPlan}
                merchName={merchName}
                handleCancel={(e) => modalCancel(e)}
                handleSubmit={(e) => modalContinue(e)}
              />
            )}
          </Grid>

          <Grid>
            {cancelmodal && (
              <CancelPlan
                title={"Cancel Plan"}
                merchName={merchName}
                handleCancel={(e) => cancelModalClose(e)}
                handleSubmit={(e) => proceedCancelModal(e)}
                planDetail={planDetail}
                addonList={addonList}
                storeName={""}
                userAddonQuantity={cancelQty}
                setCancelQty={setCancelQty}
              />
            )}
          </Grid>

          <Grid>
            {alertPopup && (
              <AlertPopup
                message={alertMessage}
                alertReason={alertReason}
                handleAlertClose={handleAlertClose}
              />
            )}
          </Grid>
          <Grid>
            {confirmPopup && (
              <ConfirmPopup
                confirmYes={removePaymentMethod}
                confirmNo={confirmNo}
              />
            )}
          </Grid>

          <Grid>
            {showContactUsPopup && (
              <PremiumContactUsModal
                toggleContactUsModal={toggleContactUsModal}
              />
            )}
          </Grid>
        </Container>
      )}

      <MKBox pt={2} mt={0} mb={0} sx={{ backgroundColor: "#F0EEEE" }}>
        <Container maxWidth="lg">
          {/* <StickyFooter content={footerroutes} /> */}
          <NewFooter />
        </Container>
      </MKBox>
    </>
  );
};

export default ChangePlanForm;
